export default __webpack_public_path__ + "locales/sr-Latn-RS/Webhooks.json?hash=cb81234479157263598cf5070c02403c";